import React from 'react';
import { Typography } from 'antd';
import PageWrapper from '../components/layout/PageWrapper';


const { Title, Paragraph } = Typography;

const TermsAndConditionsPage = () => {
    return (
        <PageWrapper>
            <Title level={2}>
                Terms and Conditions
            </Title>
            <Paragraph>
                The purpose of these terms allows us to pursue our services in an effective professional manner,
                being transparent with integrity. Clear H2o Window Cleaning Services Limited, has a five-star
                excellent customer service rating cleaning windows, gutters, fascia’s, soffits, conservatories, solar
                panels, patios and block paving, which includes driveways and external property wash-downs.
            </Paragraph>
            <Title level={4}>
                Definitions
            </Title>
            <Paragraph>
                “We” as H2O Cleaning Services Limited.
            </Paragraph>
            <Paragraph>
                “You” as our Customer.
            </Paragraph>
            <Title level={4}>
                Our Terms
            </Title>
            <Paragraph>
                1. Our price list is fixed and is the amount you would pay, with the addition of a
                booking charge, when booking our services on this website.
            </Paragraph>
            <Paragraph>
                2. Any other cleaning requirements outside of the price list, we require a viewing and a
                separate quotation. This will be FREE of charge and sent by email within 24 hours from the
                point of viewing.
            </Paragraph>
            <Paragraph>
                3. You as our customer have engaged us to conduct a cleaning service. This could be a regular
                requirement booking our services online, in person or for a specific project.
            </Paragraph>
            <Paragraph>
                4. Our service offering includes due care and attention and a time slot to ensure your
                requirements are completed at the highest standard possible.
            </Paragraph>
            <Paragraph>
                5. We respect our customers properties and recommend that you as our customer to
                physically walk around the building and ensure you are fully satisfied, this quality check is
                ideally completed when we are still present, so we can rectify any faults immediately. If you
                are unable to be at the property, we offer a 24-hour guarantee which means customers
                need to make us aware via email please, indicating what you are not happy with. We will
                respond within 24 hours. We cannot guarantee inconsistent weather conditions or any
                other dirt related contact. For example, body prints or bird faeces.
            </Paragraph>
            <Paragraph>
                6. We ensure our external work and recommend a full internal clean also to ensure both sides
                of glass are at totally clean. If only one side of the glass has been cleaned, this may result to
                windows looking dirty still. We recommend either personally cleaning inside or booking us
                to do this too, whilst we are cleaning externally.
            </Paragraph>
            <Paragraph>
                7. On completion of our work – don’t worry if you are not in, we will drop a card through your
                letterbox to advise you we have been.
            </Paragraph>
            <Paragraph>
                8. In the event whilst we are undertaking your cleaning requirements, we notice any damage,
                we will notify you immediately, so you are aware. We are diligent and want customers to
                refer us to others, so our workmanship and professionalism is paramount and would not
                want any reason for customers to blame us. If for example, you notice anything/changes
                after we have been to your property, we advise you to email us with immediate effect within
                24 hours, so we can correct for you. After this timescale, we are unable to take any
                responsibility.
            </Paragraph>
            <Title level={4}>
                Payment
            </Title>
            <Paragraph>
                9. To book your cleaning requirements, a booking charge will apply to guarantee your time slot.
                We always do our upmost adhering to time slots; however, we are unable to predict
                weather, traffic or any other disruptions.
            </Paragraph>
            <Paragraph>
                10. On completion of your booking, your balance will be collected automatically via our 3rd party payment
                system of choice, Stripe, using the card detail you provided on last step of the booking form.
            </Paragraph>
            <Title level={4}>
                Cancellations
            </Title>
            <Paragraph>
                11. In the event customers must cancel their booking time slot, we ask to re-schedule the slot to
                eliminate any confusion and charges we incur.
            </Paragraph>
            <Paragraph>
                12. We are unable to offer a refund as per point 11 above, as we understand commitments take
                priority, therefore re-scheduling is the best and most effective outcome.
                Clear H2O Cleaning Services Limited, has a right to change these terms of business.
            </Paragraph>
        </PageWrapper>
    );
};

export default TermsAndConditionsPage;
